import { getLinkTitle, getLinkSiteName } from "../helpers";
import { isGoogleDocsUrl, isNotionUrl } from "./host-urls";
export function stripGoogleDocsTitleArtifacts(text) {
    let t = text.trim();
    let prev = "";
    while (t !== prev && t.length > 0) {
        prev = t;
        t = t
            .replace(/^google\s*docs\s*[-\s:–—|.]+\s*/i, "")
            .replace(/\s*[-–—|•·.:]\s*google\s*docs\s*$/i, "")
            .replace(/\s+\(?google\s*docs\)?\s*$/i, "")
            .trim();
    }
    return t;
}
export function stripNotionTitleArtifacts(text) {
    let t = text.trim();
    let prev = "";
    while (t !== prev && t.length > 0) {
        prev = t;
        t = t
            .replace(/\s*[|–—-]\s*notion\s*$/i, "")
            .replace(/\s+\(?notion\)?\s*$/i, "")
            .trim();
    }
    return t;
}
const MAX_SLUG_TITLE_LENGTH = 80;
/** Last path segment on Notion URLs is often `Words-In-Title-<pageId>` — strip id, humanize. */
export function humanTitleFromNotionUrl(urlString) {
    if (!isNotionUrl(urlString))
        return undefined;
    try {
        const u = new URL(urlString);
        const segments = u.pathname.split("/").filter(Boolean);
        if (segments.length === 0)
            return undefined;
        let segment = segments[segments.length - 1];
        if (!segment)
            return undefined;
        segment = segment.replace(/-[a-f0-9]{32}$/i, "");
        let decoded = decodeURIComponent(segment.replace(/\+/g, " "));
        decoded = decoded.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
        if (!decoded || decoded.length < 2)
            return undefined;
        const compact = decoded.replace(/\s/g, "");
        if (/^[a-f0-9]{16,}$/i.test(compact))
            return undefined;
        if (decoded.length > MAX_SLUG_TITLE_LENGTH) {
            return `${decoded.slice(0, MAX_SLUG_TITLE_LENGTH).trimEnd()}…`;
        }
        return decoded;
    }
    catch {
        return undefined;
    }
}
/** Google Docs URLs use opaque ids in `/document/d/<id>/`; use doc kind as a readable fallback. */
export function humanTitleFromGoogleDocsUrl(urlString) {
    if (!isGoogleDocsUrl(urlString))
        return undefined;
    try {
        const u = new URL(urlString);
        const parts = u.pathname.split("/").filter(Boolean);
        const kind = parts[0];
        switch (kind) {
            case "document":
                return "Document";
            case "spreadsheets":
                return "Spreadsheet";
            case "presentation":
                return "Presentation";
            case "forms":
                return "Form";
            default:
                return undefined;
        }
    }
    catch {
        return undefined;
    }
}
/**
 * Resolved title for cloud-document cards: scraped fields first, then Notion slug / Google doc kind, else "Untitled".
 */
export function resolveCloudDocumentDisplayTitle(block, content, url) {
    const googleDocs = isGoogleDocsUrl(url);
    const notion = isNotionUrl(url);
    const candidates = [getLinkTitle(content)?.trim(), getLinkSiteName(content)?.trim(), block.title?.trim()];
    for (const raw of candidates) {
        if (!raw)
            continue;
        let t = raw;
        if (googleDocs) {
            if (/^google docs$/i.test(t))
                continue;
            t = stripGoogleDocsTitleArtifacts(t);
            if (!t || /^google docs$/i.test(t))
                continue;
        }
        else if (notion) {
            if (/^notion$/i.test(t))
                continue;
            t = stripNotionTitleArtifacts(t);
            if (!t || /^notion$/i.test(t))
                continue;
        }
        return t;
    }
    if (url) {
        if (notion) {
            const fromSlug = humanTitleFromNotionUrl(url);
            if (fromSlug)
                return fromSlug;
        }
        if (googleDocs) {
            const fromKind = humanTitleFromGoogleDocsUrl(url);
            if (fromKind)
                return fromKind;
        }
    }
    return "Untitled";
}
